import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import { FormField } from '../utils/formFieldTypes';
// import { FormFieldConsent } from '../utils/formFieldTypes';

interface ConsentPopupProps {
  open: boolean;
  field: FormField;
  // consent: FormFieldConsent;
  onAccept: () => void;
  onDecline: () => void;
  isLoading?: boolean;
}

const ConsentPopup: React.FC<ConsentPopupProps> = ({
  open,
  // consent,
  field,
  onAccept,
  onDecline,
  isLoading = false,
}) => {
  const [hasRead, setHasRead] = React.useState(false);

  const handleClose = (accepted: boolean) => {
    setHasRead(false);
    if (accepted) {
      onAccept();
    } else {
      onDecline();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => handleClose(false)}
      maxWidth='sm'
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: '#1a1a1a',
          backgroundImage: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
          borderRadius: '12px',
          border: '1px solid #FFFFFF1A',
        },
      }}
    >
      <DialogTitle
        sx={{
          color: 'white',
          fontSize: '18px',
          fontWeight: 'bold',
          borderBottom: '1px solid #FFFFFF1A',
        }}
      >
        {field.title}
        {/* {consent.title} */}
      </DialogTitle>

      <DialogContent
        sx={{
          color: '#a3a3a3',
          padding: '20px',
          maxHeight: '400px',
          overflowY: 'auto',
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: '#2d2d2d',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#666',
            borderRadius: '4px',
          },
        }}
      >
        {/* Render consent content as HTML */}
        <Box
          // dangerouslySetInnerHTML={{ __html: consent.content }}
          dangerouslySetInnerHTML={{ __html: field.content }}
          sx={{
            '& a': {
              color: '#f2674a',
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'underline',
              },
            },
            '& p': {
              marginBottom: '10px',
              lineHeight: '1.6',
            },
            '& ul': {
              marginLeft: '20px',
              marginBottom: '10px',
            },
            '& li': {
              marginBottom: '5px',
            },
          }}
        />

        {/* Checkbox to confirm reading */}
        <Box mt='20px' pt='20px' borderTop='1px solid #FFFFFF1A'>
          <FormControlLabel
            control={
              <Checkbox
                checked={hasRead}
                onChange={(e) => setHasRead(e.target.checked)}
                sx={{
                  color: '#f2674a',
                  '&.Mui-checked': {
                    color: '#f2674a',
                  },
                }}
              />
            }
            label={
              <Typography sx={{ color: '#a3a3a3', fontSize: '14px' }}>
                I have read and agree to the above terms
              </Typography>
            }
          />
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          padding: '20px',
          borderTop: '1px solid #FFFFFF1A',
          gap: '10px',
        }}
      >
        <Button
          onClick={() => handleClose(false)}
          disabled={isLoading}
          sx={{
            color: '#a3a3a3',
            border: '1px solid #FFFFFF33',
            borderRadius: '50px',
            padding: '10px 30px',
            '&:hover': {
              backgroundColor: '#FFFFFF0A',
            },
          }}
        >
          Decline
        </Button>

        <Button
          onClick={() => handleClose(true)}
          disabled={!hasRead || isLoading}
          sx={{
            color: 'white',
            backgroundColor: '#f2674a',
            borderRadius: '50px',
            padding: '10px 30px',
            fontWeight: 'bold',
            '&:disabled': {
              backgroundColor: '#a3a3a3',
              color: '#666',
            },
            '&:hover': {
              backgroundColor: '#ff5c3d',
            },
          }}
        >
          Accept
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConsentPopup;
